import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const isEnhancedBuyerIncentivesVariant = (): boolean =>
    getAbTestV2('enhancedBuyerIncentives')?.variant === 'variant';

export const isBuyerIncentivesDesktopVariant1 = (): boolean =>
    getAbTestV2('enhancedBuyerIncentivesCheckoutDesktop')?.variant === 'variant-1';

export const isBuyerIncentivesDesktopVariant2 = (): boolean =>
    getAbTestV2('enhancedBuyerIncentivesCheckoutDesktop')?.variant === 'variant-2';
